module.exports = __webpack_public_path__ + "img/poly-11.93347c98.png";